export default {
	success: null,
	error: null,
	title: null,
	message: null,
	status: null
}
